import React from 'react';

// Logo avec l'icône PWA (belle fourchette dorée sur fond vert)
export const SmartbouffeLogoLarge = ({ className = "" }) => (
  <div className={className} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <img 
      src="/icons/icon-192x192.png" 
      alt="SmartBouffe" 
      style={{ 
        width: '50px', 
        height: '50px', 
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }} 
    />
    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.1' }}>
      <span style={{ fontFamily: 'Playfair Display, serif', fontSize: '22px', fontWeight: '600', color: '#3A4A3E' }}>
        smart
      </span>
      <span style={{ fontFamily: 'Playfair Display, serif', fontSize: '22px', fontWeight: '600', color: '#87A96B' }}>
        bouffe
      </span>
    </div>
  </div>
);

// Petit logo pour le header (juste l'icône fourchette)
export const SmartbouffeLogoSmall = ({ className = "" }) => (
  <img 
    src="/icons/icon-96x96.png" 
    alt="SmartBouffe" 
    className={className}
    style={{ 
      width: '40px', 
      height: '40px', 
      borderRadius: '10px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
    }} 
  />
);

export const FleurDeLys = ({ className = "" }) => (
  <img 
    src="https://customer-assets.emergentagent.com/job_recipe-ai-21/artifacts/aqgbbm7b_Fleur_de_lys_du_qu%C3%A9bec.svg.png"
    alt="Fleur-de-lys du Québec"
    className={className}
    style={{
      width: 'auto',
      height: '100%',
      objectFit: 'contain'
    }}
  />
);

export default SmartbouffeLogoLarge;
